import {TStarResponse} from '../../../coreGlobal/models/franchise/franchise'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'

type TStarProps = {
  stars: TStarResponse
}
export const Star = ({stars}: TStarProps) => {
  return (
    <div
      className='tab-pane fade show active p-4 pt-0 pt-md-4'
      id='pills-data-partnership'
      role='tabpanel'
      aria-labelledby='pills-checklist-tab'
    >
      <div className='card mb-5 mb-xl-10'>
        <>
          <div className='card-header cursor-pointer'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>Estrelas</h3>
            </div>
          </div>
          <div className='card-body py-3'>
            <div className='card-body p-9'>
              <table className='table table-row-dashed table-row-gray-300'>
                <thead>
                  <tr className='fw-bolder fs-6 text-gray-800'>
                    <th></th>
                    <th>Número</th>
                    <th>Valor Mínimo</th>
                    <th>Valor Máximo</th>
                    <th>Obs</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(stars) &&
                    stars?.map((field, index) => (
                      <tr key={`stars${index}`}>
                        <td>{field?.description}</td>
                        <td>{field?.starsCount}</td>
                        <td>{formatMonetaryToBr(field?.minAmount)}</td>
                        <td>{formatMonetaryToBr(field?.maxAmount)}</td>
                        <td>{field?.observation}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      </div>
    </div>
  )
}
